import BreadCrumb from '../../../../components/Breadcrumb/breadCrumb'
import steps from '../../../../components/steps/steps'
import backButton from '../../../../components/backButton/backButton.vue'
import * as requestApi from '@/utils/appointment.url'
import {
  Loading
} from 'element-ui'

export default {
  name: 'condition',
  components: {
    BreadCrumb,
    steps,
    backButton
  },
  data () {
    return {
      activeIndex: null,
      reservatForm:[],
      selectReserveTime: [],//选择时间段列表
      timeOrderJsonData: [],
      selectObj:{
        date:'',
        dateToken:'',
        week:''
      },
      currentYear: '', // 当前年份
      currentMonth: '', // 当前月份
      currentDay: '', // 当前日
      today: '', // 当前日期
      contantOrderJson: [],
      weekDay: ['星期天', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'],
      monthDay: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月'],
      loading: null,
      stepsType: this.$route.query.stepsType
    }
  },
  methods: {
    // 获取预约日期
    getAppointmentDate(){
      requestApi.appointmentDate({
        bsSeq:this.$route.query.bsSeq
      },'get').then(res => {
        if(Number(res.status) === 200){
          this.timeOrderJsonData = res.data;
          this.loading.close()
          this.formatReserveDate();
        }else{
          this.$message.error(res.desc);
        }
      }).catch(err => {
        console.log(err);
      });
    }, 
    // 获取预约时间
    getAppointmentTime(obj){
      requestApi.appointmentTime({
        bsSeq:this.$route.query.bsSeq,
        date:obj.date,
        dateToken:obj.dateToken
      },'post').then(res => {
        if(Number(res.status) === 200){
          this.selectReserveTime = res.data;
        }else{
          this.$message.error(res.desc);
        }
      }).catch(err => {
        console.log(err);
      })
    },
    // 关闭弹窗回传状态
    handleClose() { 
      this.$emit("input", false);
    }, 
    // 格式化时间
     formatReserveDate () {
      let _date = new Date()
      this.currentYear = _date.getFullYear()
      this.currentMonth = (_date.getMonth() + 1) > 9 ? _date.getMonth() + 1 : ('0' + (_date.getMonth() + 1))
      this.currentDay = _date.getDate()
      this.today = this.currentYear + '-' + this.currentMonth + '-' + this.currentDay
      for (var i = 0; i < this.timeOrderJsonData.length; i++) {
        var week = this.timeOrderJsonData[i].date;
        var dateToken = this.timeOrderJsonData[i].dateToken;
        var myWeek = new Date(Date.parse(week.replace(/-/g, '/')))
        var weeks, month, dateDay, attr
        weeks = this.weekDay[myWeek.getDay()]
        /* 将日期转为星期 */
        month = this.monthDay[new Date(week).getMonth()]
        /* 将日期转为月份 */
        dateDay = new Date(week).getDate()
        /* 获取多少号 */
        attr = { 
          'date': week,
          'month': month,
          'week': weeks,
          'day': dateDay, 
          'dateToken':dateToken
        }
        this.contantOrderJson.push(attr) 
      }
    }, 
    // 选择预约日期
    isActiveIndex (item, index) {
        this.activeIndex = index;
        this.selectObj.date = item.date;
        this.selectObj.dateToken = item.dateToken;
        this.selectObj.week = item.week;
        this.getAppointmentTime(item);
    },
    // 保存预约信息
    handleReservat (val) {
      let appointmentInfo = {
        ...this.selectObj,
        timeToken:val.timeToken,
        timeSeq:val.seq,//预约时间段主键
        beginTime:val.beginTime,//时间段开始时间
        endTime:val.endTime, //时间段结束时间
      }
      this.$router.push({
        path: '/basicInfo',
        query: {
          ...this.$route.query,
          appointmentInfo:appointmentInfo,
          remainNum: val.canCount - val.hasCount, // 剩余预约号数量
          unitSeq: this.$route.query.unitSeq,
          hallSeq: this.$route.query.hallSeq,
          stepsType:　this.$route.query.stepsType,
          extentedType:this.$route.query.extentedType,
        }
      })
    }
  },
  created () {
    this.loading = Loading.service({
      fullscreen: true
    })
    this.getAppointmentDate(); 
  }
}
